"use strict";
var $ = require("../internals/export");
var floor = Math.floor;
var log = Math.log;
var LOG2E = Math.LOG2E;
$({ target: "Math", stat: true }, {
  clz32: function clz32(x) {
    var n = x >>> 0;
    return n ? 31 - floor(log(n + 0.5) * LOG2E) : 32;
  }
});
